import { useRequiredParams } from '@pba/react-router';
import { OrganizationLayout, OrganizationsPrograms } from 'features/organizations';
import { useGetPathToEntityDetail } from '../../hooks';

const PageOrganizationsPrograms = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <OrganizationLayout organizationId={organizationId}>
      {(organization) => (
        <OrganizationsPrograms
          getPathToProgramDetail={(id) => getPathToEntityDetail(id, { entityType: 'program' })}
          organization={organization}
        />
      )}
    </OrganizationLayout>
  );
};

export default PageOrganizationsPrograms;
